/**
 *  paths
 */
export const Paths = {
  BASE: "/",
  MY_DATA: "my-data",
  DASHBOARD: "dashboard",
  REPORTS: "reports",
  ADD_DRIVER: "add-driver",
  VEHICLES_CREATE: "vehicles-create",
  VEHICLE_KPIS: "/my-data/vehicle-kpis",
  FLEET_VIEW: "fleet-view",
};
